module.exports = __webpack_public_path__ + "img/work.bd85f681.png";